module.exports = __webpack_public_path__ + "static/media/slash.d9fda343.svg";